import React from "react";
import { Helmet } from "react-helmet";

function Reclami() {

  return (
    <div>
      <Helmet>
        <title>Reclami – Assistenza Trasparente e Risposte Puntuali | Carefidelity</title>
        <meta name="description" content="Hai bisogno di segnalare un problema? Carefidelity ti garantisce un processo di gestione reclami chiaro, rapido e conforme alla normativa. Scopri come fare un reclamo in pochi semplici passi." />
      </Helmet>
      <div className="bg-[#fafafa] flex justify-center items-center pt-36 pb-10 px-10">
        <div className="w-full xl:w-1/2 text-center text-gray-700 font-medium text-lg">
          <p className="text-4xl font-semibold text-black mt-10 mb-5 uppercase">
            RECLAMI
          </p>
          <hr className="my-10"></hr>
          <p>
            Il contraente, assicurato, o beneficiario, non soddisfatto dei contratti o servizi forniti, nonché del
            comportamento dell’Agente, Intermediario o collaboratore, con cui entrano in contatto, possono comunicare i
            loro reclami per iscritto secondo le seguenti modalità:
          </p>
          <ul className="mt-10">
            <li>
             <span className="font-bold">E-mail:</span>  <a href="mailto:info@carefidelity.it" target="_blank" rel="noreferrer">info@carefidelity.it</a>
            </li>
            <li>
             <span className="font-bold">PEC:</span> <a href="mailto:carefidelitysrl@pec.carefidelity.it" target="_blank" rel="noreferrer">carefidelitysrl@pec.carefidelity.it</a>
            </li>
            <li>
             <span className="font-bold">E-mail:</span> <a href="mailto:reclami@carefidelity.it" target="_blank" rel="noreferrer">reclami@carefidelity.it</a>
            </li>
            <li>
             <span className="font-bold">Posta:</span> Care Fidelity Srl Via Monte Baldo, 14/D - 37069 Villafranca di Verona VR
            </li>
          </ul>
          <p className="mt-10 mb-5">Indicando i seguenti dati essenziali:</p>
            <ul>
              <li>
                Dati anagrafici del reclamante (nome, cognome, indirizzo postale – se disponibile anche indirizzo PEC – recapito telefonico)
              </li>
              <li>
                Indicazione dell’impresa di assicurazione di cui si lamenta l’operato
              </li>
              <li>
                Chiara e sintetica descrizione del motivo di lamentela
              </li>
            </ul>
            <hr className="my-10"></hr>

            <p className="mt-10 mb-5">Qualora non dovesse ritenersi soddisfatto dell’esito del reclamo o in caso di assenza di riscontro nel termine
            massimo di quarantacinque giorni, potrà rivolgersi a:</p>
            <ul>
              <li>
                Istituto per la Vigilanza sulle Assicurazioni IVASS - Servizio Tutela Utenti Via del Quirinale, 21 -
                00187 Roma
              </li>
              <li>
                PEC: tutela.consumatore@pec.ivass.it (abilitata a ricevere messaggi solo da caselle di Posta
                Elettronica Certificata - PEC)
              </li>
              <li>
                PEO (posta elettronica ordinaria) dell’Istituto: email@ivass.it
              </li>
            </ul>
            <p>fornendo copia del reclamo già inoltrato all&#39;impresa ed il relativo riscontro anche utilizzando il modello
            presente nel sito  www.ivass.it/consumatori/reclami/</p>
          <hr className="my-10"></hr>
        </div>
      </div>
    </div>
  );
}

export default Reclami;
